module.exports = __webpack_public_path__ + "img/red-upload-icon.3f40d18e.svg";